module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Thin-Alphabetic.23437631.woff";